import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="localstorage" id="localstorage"></a>
    <h1 {...{
      "id": "windowlocalstorage"
    }}>{`window.localStorage`}</h1>
    <p>{`Provides a local key-value store useful for setting preferences and other kinds of data.
This data is technically persistent, but can be cleared in a variety of ways,
so you should not store data using localStorage that you cannot otherwise reconstruct.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Do not store passwords or other secure forms of data using `}<inlineCode parentName="p">{`localStorage`}</inlineCode>{`. Instead, use `}<a parentName="p" {...{
        "href": "/photoshop/uxp/2022/uxp-api/reference-js/Modules/uxp/Key-Value%20Storage/SecureStorage/"
      }}>{`storage.secureStorage`}</a></p>
    <a name="localstorage-length" id="localstorage-length"></a>
    <h2 {...{
      "id": "length--number"
    }}>{`length : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Number of items stored in the local storage.`}</p>
    <a name="localstorage-key" id="localstorage-key"></a>
    <h2 {...{
      "id": "keyindex"
    }}>{`key(index)`}</h2>
    <p>{`Returns the name of the nth key in the local storage.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - Name of the key. If the index does not exist, null is returned.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer representing the number of the key`}</td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-getitem" id="localstorage-getitem"></a>
    <h2 {...{
      "id": "getitemkey"
    }}>{`getItem(key)`}</h2>
    <p>{`Gets the value for the key from the local storage.
Returns null if the key does not exist.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - Value corresponding to the key as string. If the key does not exist, null is returned.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key to retrieve the value of.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-setitem" id="localstorage-setitem"></a>
    <h2 {...{
      "id": "setitemkey-value"
    }}>{`setItem(key, value)`}</h2>
    <p>{`Adds key and value to the local storage.
Updates the value if the given key already exists.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Error`}</inlineCode>{` If it fails to store`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key to set value`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value for the key`}</td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-removeitem" id="localstorage-removeitem"></a>
    <h2 {...{
      "id": "removeitemkey"
    }}>{`removeItem(key)`}</h2>
    <p>{`Removes a key/value pair from the local storage if it exists.
Nothing happens if there's no item associated with the given key.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key to remove`}</td>
        </tr>
      </tbody>
    </table>
    <a name="localstorage-clear" id="localstorage-clear"></a>
    <h2 {...{
      "id": "clear"
    }}>{`clear()`}</h2>
    <p>{`Remove all key/value pairs from the local storage.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      